
import React from 'react';
import { ChevronsRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { navItems } from './navItems';
import { NavItem } from './types';

interface CollapsedSidebarProps {
  activePage: string;
  setActivePage: (page: string) => void;
  setIsCollapsed: (value: boolean) => void;
}

const CollapsedSidebar: React.FC<CollapsedSidebarProps> = ({
  activePage,
  setActivePage,
  setIsCollapsed
}) => {
  // Flatten nav items including children for the collapsed view
  const getFlattenedNavItems = () => {
    const flattened: NavItem[] = [];
    
    navItems.forEach(item => {
      flattened.push(item);
      
      // Check if item.children exists before trying to access it
      if (item.children && item.children.length > 0) {
        flattened.push(...item.children);
      }
    });
    
    return flattened;
  };

  const flattenedItems = getFlattenedNavItems();

  return (
    <div className="h-full w-16 flex flex-col border-r border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 shadow-sm dashboard-sidebar">
      <button 
        onClick={() => setIsCollapsed(false)}
        className="w-full py-4 flex justify-center hover:bg-gray-50 dark:hover:bg-gray-800 border-b border-gray-200 dark:border-gray-800 flex-shrink-0 text-gray-500 dark:text-gray-400"
      >
        <ChevronsRight className="h-5 w-5" />
      </button>
      
      <div className="w-full flex flex-col items-center pt-3 px-2 overflow-y-auto flex-1">
        {flattenedItems.map((item) => (
          <div 
            key={item.id} 
            className={cn(
              "relative w-8 h-8 my-2 flex items-center justify-center rounded-full cursor-pointer flex-shrink-0",
              activePage === item.id 
                ? "bg-indigo-500 text-white" 
                : "bg-indigo-100 text-indigo-600 dark:bg-indigo-900 dark:text-indigo-300"
            )}
            onClick={() => {
              setActivePage(item.id);
            }}
            title={typeof item.label === 'string' ? item.label : item.id}
          >
            {item.icon && (
              <div className="flex items-center justify-center w-full h-full">
                {item.icon}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CollapsedSidebar;
